/**
 * External dependencies
 */
import React, { useState } from "react";
import { Stack } from "@towersystems/towersystems-design-system";
import { map, noop } from "lodash";

/**
 * Internal dependencies
 */
import Item from "./item";

const DataTypeList = ({ items, value, onChange = noop }) => {
  const [dataType, setDataType] = useState(value);

  const handleOnChange = (value) => {
    setDataType(value);
    onChange(value);
  };

  return (
    <Stack className="report-builder__data-type-list" space="medium">
      {map(items, ({ key, ...item }) => (
        <Item
          key={key}
          {...item}
          selected={item.value === dataType}
          onClick={handleOnChange}
        />
      ))}
    </Stack>
  );
};

export default DataTypeList;
